
import React, { Component } from 'react';

import './../../../../scss/App.scss';

class GamePage extends Component {
	constructor(props){
		super(props);

		this.state = {
			answer : "",
			defaultValue : "",
			currentValue : "",
			readOnly : false,
			altWords : [],
			bonusSet : null

		};

		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnFocus = this.handleOnFocus.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.moveCursorToEnd = this.moveCursorToEnd.bind(this);
		this.checkAnswer = this.checkAnswer.bind(this);
	}

	componentDidMount(){
		//console.log("Field mounted");

		this.setDefaultValue();
		this.setAltWords();

		this.setState({
			answer : this.props.answer.toUpperCase(),
			bonusSet : this.props.bonusSet
		});
	}

	componentDidUpdate(prevProps, prevState){
		// if reach end of field by typing
		if(this.state.currentValue.length === this.state.answer.length){
			// force blur (which will then validate answer)
			this.refs.field.blur();
		}

		// play reveal sound
		//console.log("Field :: componentDidUpdate - this.props.showAnswers ", this.props.showAnswers);
		//console.log("Field :: componentDidUpdate - prevProps.showAnswers ", prevProps.showAnswers);
		if(this.props.showAnswers === true && prevProps.showAnswers !== true){
			window.sounds.reveal.play();
		}


		// if parents "check answer" is different, check if matches alt list words
		if(this.props.checkAnswer !== prevProps.checkAnswer && this.state.readOnly === false){
			// only check answers from same set
			if(this.state.bonusSet === this.props.currentSet){
				//console.log("Field :: componentDidUpdate - parent telling us to check answer");
				this.checkAnswer(this.props.checkAnswer);
			}
		}
	}

	setDefaultValue(){
		const answer = this.props.answer.trim();

		// determine if is multi worded answer
		if(answer.indexOf(" ") > -1){
			var wordArray = answer.split(" ");
			var blankedOutWords = "";


			for(let i = 0; i < wordArray.length; i++){
				blankedOutWords = blankedOutWords + " " + this.blankOutWord(wordArray[i]);
			}

			this.setState({
				defaultValue : blankedOutWords.trim(),
				currentValue : blankedOutWords.trim()
			});
		}
		else {
			this.setState({
				defaultValue : this.blankOutWord(answer),
				currentValue : this.blankOutWord(answer)
			});
		}
	}

	blankOutWord(word){
		var blankedOutWord = word.charAt(0).toUpperCase();

		for(let i = 1; i < word.length; i++){
			blankedOutWord += "_";
		}

		return blankedOutWord;
	}

	setAltWords(){
		const answer = this.props.answer.toUpperCase();
		const altWordList = window.alternateWords[answer];

		if(altWordList){
			this.setState({
				altWords : [...altWordList]
			});
		}
	}

	handleOnChange(e){
		//console.log("handleOnChange  e:", e.target.value);
		//console.log("handleOnChange  e.length:", e.target.value.length);

		var nextValue = e.target.value.toUpperCase();

		// if first letter is typed in 2nd position, ignore it
		if(e.target.value.length === 2){
			if(nextValue.charAt(0) === nextValue.charAt(1)){
				nextValue = nextValue.charAt(0);
			}
		}

		/*
		// check if match alt words
		const isAltWord = this.isAltWord(nextValue);

		if(isAltWord !== false){
			//console.log("===== handle success");
			nextValue = isAltWord;

			//this.showCorrectAnswerCue();
			//this.props.handleFieldIsFocused(false);

			this.setState({
				currentValue : this.state.answer,
				readOnly : true
			});
		}
		else {
			this.setState({
				currentValue : nextValue
			});
		}
		*/

		this.setState({
			currentValue : nextValue
		});

		// update parent so that it can check all fields
		this.props.updateAnswerHandler(nextValue);
	}

	checkAnswer(answer){
		//console.log("Field :: checkAnswer");
		// check answers from other fields if not already answered

		if(this.state.readOnly === false){
			//console.log("Field :: checkAnswer - not readOnly ======");

			// check if match alt words
			const isAltWord = this.isAltWord(answer);
			//console.log("Field :: checkAnswer - isAltWord : ", isAltWord);

			if(isAltWord !== false){
				//console.log("===== handle success");
				answer = isAltWord;

				//this.showCorrectAnswerCue();
				//this.props.handleFieldIsFocused(false);

				this.setState({
					currentValue : this.state.answer
				});

				this.showCorrectAnswerCue();
			}
			else if(answer === this.state.answer){
				//console.log("===== handle success 2");
				this.setState({
					currentValue : this.state.answer
				});
				
				this.showCorrectAnswerCue();
			}
		}
	}

	isAltWord(word){
		//console.log("this.state.altWords", this.state.altWords);

		for(let i = 0; i < this.state.altWords.length; i++){
			if(this.state.altWords[i].toUpperCase() === word){
				//console.log("Field :: isAltWord - YES word: ", word);
				return word;
			}
			else{
				//console.log("Field :: isAltWord - no word: ", word);
			}
		}

		return false;
	}

	handleOnFocus(){
		//console.log("Field :: handleOnFocus");

		this.setState({
			currentValue : this.props.answer.charAt(0).toUpperCase()
		});

		this.props.handleFieldIsFocused(true);

		this.moveCursorToEnd(this.refs.field)
	}

	moveCursorToEnd(el){
		//console.log("Field :: moveCursorToEnd");

		setTimeout(function(){
			if (typeof el.selectionStart === "number") {
		    	//console.log("Field :: moveCursorToEnd a");
		        el.selectionStart = el.selectionEnd = el.value.length;
		    } else if (typeof el.createTextRange !== "undefined") {
		    	//console.log("Field :: moveCursorToEnd b");
		        el.focus();
		        var range = el.createTextRange();
		        range.collapse(false);
		        range.select();
		    }
		}, 10);
	}

	handleOnBlur(){
		//console.log("Field :: handleOnBlur   currentValue: " + this.state.currentValue + "    answer: " + this.state.answer);

		if(this.props.revealingAnswersMode === false){
			if(this.state.currentValue === this.state.answer.charAt(0)){
				console.log("Field :: handleOnBlur - is default value, restore default");
				
				this.setState({
					currentValue : this.state.defaultValue
				});
			}
			else if(this.state.currentValue === this.state.answer){
				console.log("Field :: handleOnBlur - state.currentValue === state.answer - correct answer should have been caught already");
				//this.showCorrectAnswerCue();	
			}
			else if(this.state.currentValue.length === this.state.answer.length) {
				console.log("Field :: handleOnBlur - has reached end length and is not correct");
				this.showWrongAnswerCue();
			}
			else {
				console.log("Field :: handleOnBlur - else restore default and error cue");

				this.setState({
					currentValue : this.state.defaultValue
				});

				this.showWrongAnswerCue();
			}
		}

		this.props.handleFieldIsFocused(false);
	}

	showWrongAnswerCue(){
		//console.log("WRONG ANSWER!");

		this.setState({
			currentValue : this.state.defaultValue
		});

		this.props.handleWrongAnswer();

		window.sounds.wrong.play();
	}

	showCorrectAnswerCue(){
		//console.log("CORRECT ANSWER!");

		this.setState({
			readOnly : true
		});

		this.props.handleCorrectAnswer();

		window.sounds.correct.play();
	}

	render(){
		//console.log("Field :: render currentValue", this.state.currentValue);

		let readOnly = (this.state.readOnly) ? " readOnly" : "";

		let value = (this.props.showAnswers) ? this.state.answer : this.state.currentValue;

		return(
			<div className="field_wrapper">
				<input className={"field" + readOnly} type="text" maxLength={this.props.answer.length} size={this.props.answer.length + 5} value={value} ref="field" onChange={this.handleOnChange} onFocus={this.handleOnFocus} onBlur={this.handleOnBlur} onMouseUp={() => this.moveCursorToEnd(this.refs.field)} />
			</div>
		);
	}
}

export default GamePage;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/game/Field.js